import { Outlet } from 'react-router';

import { TopBar } from '../top-bar';

import styles from './style.module.css';

// The page around every section: the top bar, then the section in the content
// column. The column is the same on every size; only its gutter changes.
export function Frame() {
  return (
    <>
      <TopBar/>

      <main className={ styles.main }>
        <Outlet/>
      </main>
    </>
  );
}
